export default __webpack_public_path__ + "31bc07947006b28d08a5cf7853c5a45b.svg";